import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "../styles/SharedMediaViewer.css";

function SharedMediaViewer({ isOpen, type, url, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
      if (videoRef.current) {
        videoRef.current.pause();
      }
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen && type === "video" && videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [isOpen, type, url]);

  if (!isOpen || !url) return null;

  return createPortal(
    <div className="shared-media-viewer-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <button
        type="button"
        className="shared-media-viewer-close"
        onClick={onClose}
        aria-label="Close"
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div
        className="shared-media-viewer-content"
        onClick={(e) => e.stopPropagation()}
      >
        {type === "video" ? (
          <video
            ref={videoRef}
            src={url}
            controls
            playsInline
            className="shared-media-viewer-video"
          />
        ) : (
          <img src={url} alt="" className="shared-media-viewer-image" />
        )}
      </div>
    </div>,
    document.body
  );
}

export default SharedMediaViewer;
